import { Outlet } from 'react-router';

// ==============================|| LAYOUT - BLANK PAGES ||============================== //

export default function PagesLayout() {
  return <Outlet />;
}
